import React from 'react';

const SuppliersPage = React.lazy(() => import('pages/suppliers'));
const SuppliersDetailsPage = React.lazy(() => import('pages/suppliers/edit'));
const SubmitNewSupplierPage = React.lazy(() => import('pages/suppliers/edit'));

const policies = [{ resource: 'trends', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <SuppliersPage />
  },
  {
    path: 'edit/:vendorID',
    policies: policies,
    component: <SuppliersDetailsPage />
  },
  {
    path: 'new',
    policies: policies,
    component: <SubmitNewSupplierPage />
  }
];
